import { Controller } from 'stimulus';
import Chart from 'chart.js/auto';

// Renders the small "Closed by users vs. system" donut on the Alert
// Outcomes Overview totals box. Two segments only; the surrounding HAML
// already labels them, so the chart is decoration + tooltip — no legend.
export default class extends Controller {
  static values = { data: Object };

  connect() {
    const { labels, values, colors } = this.dataValue;

    this.chart = new Chart(this.element, {
      type: 'doughnut',
      data: {
        labels,
        datasets: [
          {
            data: values,
            backgroundColor: colors,
            borderWidth: 0,
            hoverOffset: 4,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '65%',
        events: [],
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
      },
    });
  }

  disconnect() {
    this.chart?.destroy();
  }
}
